import type { CSSProperties } from 'react';

import { RUN_TOOL_CARDS } from '../../components/screens/RunToolsScreen';
import type { RunToolCard } from '../../components/screens/helpers/runScreenTypes';
import { AppToolMark, MODEL_LOGOS } from './AppToolsView';

const MAX_MARKS = 7;

// Models first, then tools; one mark per distinct logo so the stack never repeats itself.
const LINEUP_MARKS: RunToolCard[] = (() => {
  const seen = new Set<unknown>();
  const ordered = [
    ...RUN_TOOL_CARDS.filter((tool) => tool.kind === 'model'),
    ...RUN_TOOL_CARDS.filter((tool) => tool.kind !== 'model')
  ];

  return ordered.filter((tool) => {
    const key = MODEL_LOGOS[tool.id] ?? tool.logo;

    if (!key || seen.has(key)) {
      return false;
    }

    seen.add(key);
    return true;
  }).slice(0, MAX_MARKS);
})();

const HIDDEN_COUNT = RUN_TOOL_CARDS.length - LINEUP_MARKS.length;

/** Shows at a glance that every assessment runs many models and tools at once. */
function AppLineup({ onOpen }: { onOpen: () => void }) {
  return (
    <div className="app-lineup">
      <button
        type="button"
        className="app-lineup-stack"
        aria-label={`See the ${RUN_TOOL_CARDS.length} models and tools that run in parallel`}
        title={RUN_TOOL_CARDS.map((tool) => tool.title).join(' · ')}
        onClick={onOpen}
      >
        {LINEUP_MARKS.map((tool, index) => (
          <span key={tool.id} className="app-lineup-mark" style={{ '--i': index } as CSSProperties}>
            <AppToolMark tool={tool} />
          </span>
        ))}
        {HIDDEN_COUNT > 0 && <span className="app-lineup-more">+{HIDDEN_COUNT}</span>}
      </button>
    </div>
  );
}

export default AppLineup;
